// opervex-frontend/src/Opervex/Financial/index.js

import Categories from "./Categories";
import Entries from "./Entries";
import Accounts from "./Accounts";

class Financial {
  constructor(api) {
    this.Categories = new Categories(api);
    this.Entries = new Entries(api);
    this.Accounts = new Accounts(api);
  }
}
export default Financial;
